
import "./UserDailyDiary.css";
import ManagerSubHeaderLinks from "../../components/managerSubHeaderLinks/ManagerSubHeaderLinks.jsx";
import { useLocation, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import moment from "moment";
import DiaryTimeLine from "../../components/diaryTimeline/DiaryTimeline.jsx";
import LoadingSpinner from "../../components/loadSpinner/LoadingSpinner.jsx";
import UserShortProfile from "../../components/userShortProfile/UserShortProfile.jsx";
import DefaultProfileImage from "../../medias/images/default.jpg";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { getUserDiaryRequest, requestGetImagesFromBucket, updateTimeCardsRequest } from "../../services/wisdomServices/trackingService";
import { getAgentProjectsRequest } from "../../services/wisdomServices/projectService";
import { getUserInformations } from "../../services/wisdomServices/userService";
import { getSessionItem } from "../../utils/helper/session";
import WisdomDropdown from "../../components/dropdown/WisdomDropdown.jsx";
import { timezones } from "../../utils/helper/timezones";
import { getUserTimezoneOffset } from "../../utils/helper/splitUserOffset";
import {Calendar} from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import { Can } from "../../security/Can.jsx";
import { PERMISSIONS } from "../../security/permissions.generated.js";
/**
 * @function UserDailyDiary
 * @returns {JSX.Element} - user daily diary page
 */
function UserDailyDiary() {
  const user = getSessionItem("User");
  const params = useParams();
  const location = useLocation();
  const rawDate = location.state?.date;
  const initialDiaryDate = rawDate
    ? new Date(`${rawDate}T00:00:00`)
    : new Date();
  const [selectedDiaryDate, setSelectedDiaryDate] = useState(initialDiaryDate);
  const [timeOffset, setTimeOffset] = useState(getUserTimezoneOffset());
  const [timezone, setTimezone] = useState(user.timezone)
  const [timecards, setTimecards] = useState([]);
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [euser, setEuser] = useState(0);
  const [loadingImages, setLoadingImages] = useState(true);
  const [visible, setVisible] = useState(false);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);

  const [selectAll, setSelectAll] = useState(false);
  const [selectedBoxes, setSelectedBoxes] = useState([]);
  const [isManuallySelected, setIsManuallySelected] = useState(false);


  const cardStatus = [
    { id: 0, name: "Productive", value:"productive" },
    { id: 4, name: "Marked", value:"markAsActive"},
    { id: 6, name: "Rejected", value:"rejected" },
  ];

  /**
   * @async
   * @function getSummaryDetails
   * @param {number} offset 
   * @description - loads daily tracking summary for the selected user
   */
  const getSummaryDetails = async (offset) => {
    const keys = {
      date: moment(selectedDiaryDate).format("YYYY-MM-DD"),
      id: Number.parseInt(params.employeeId),
      offset,
    };

    const data = await getUserDiaryRequest(keys.id, keys.date, keys.offset)
    if (!data || data.length <= 0) {
      setSummary([]);
    } else {
      setSummary(data);
    }
    setLoadingImages(false);
    setLoading(false);
  };
  
  /**
   * @async
   * @function handleUpdateCards
   * @description - opens the bulk update dialog and prepares selected cards
   */
  const handleUpdateCards = async () => {
    setDialogVisible(true);
    setTimecards(selectedBoxes.map(Number));
  };

  /**
   * @function changeTimeOffset
   * @param {number} offset 
   * @description - updates pagination offset
   */
  const changeTimeOffset = (offset) => {
    const str = offset.value.split(" ")
    setTimezone(offset.value)
    setTimeOffset(str[1])
    getSummaryDetails(str[1]);
  };

  /**
   * @async
   * @function getUserProjects
   * @description - fetches projects assigned to the selected user
   */
  const getUserProjects = async () => {
    const response = await getAgentProjectsRequest(params.employeeId, false, false, 1, 100)
    const list = (response.data || []).map((e) => ({ id: e.id, name: e.name }));
    setProjects(list);
  };

  const uncheckTimeCards = () => {
    setSelectedBoxes([]);
    setSelectAll(false);
    setTimecards([]);
    setIsManuallySelected(false);
  };

  /**
   * @async
   * @function handleSubmitUpdateTimeCard
   * @description - submits bulk update for selected time cards
   */
  const handleSubmitUpdateTimeCard = async () => {
    try {
      setDialogVisible(false);
      
      const keys = {
        cardsId: timecards,
      };
  
      if(selectedProject){
        keys.projectId = selectedProject.id
      }
      if(selectedStatus !== null){
        keys.status = selectedStatus
      }
      
      await updateTimeCardsRequest(user.id, keys);
      setSelectedProject(null);
      setSelectedStatus(null);
      uncheckTimeCards();
      setLoading(true);
      await getSummaryDetails(timeOffset);
      
    } catch (error) {
      console.error(error)
    }
  };
  /**
   * @async
   * @function getUser
   * @description - fetches user details and profile image
   */
  const getUser = async () => {
    try {
      const u = await getUserInformations(Number.parseInt(params.employeeId))
      if (u.image === null) {
        u.image = DefaultProfileImage;
      } else {
        const blob = await requestGetImagesFromBucket(u.id, u.image, "profile")
        u.image = URL.createObjectURL(blob);
      }
      setEuser(u);
    } catch (error) {
      console.error(`[${new Date().toISOString()}] Error in getUser():`, error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const results = await Promise.allSettled([
          getUserProjects(), 
          getSummaryDetails(timeOffset), 
          getUser()
        ]);
        results.forEach((r, i) => r.status === "rejected" && console.error(`Error in function ${i + 1}:`, r.reason));
      } catch (error) {
        console.error("ERROR: ", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedDiaryDate]);

  useEffect(() => {
    if (isManuallySelected) return;

    const checkboxes = document.querySelectorAll(".cards-checkboxes");
    if (selectAll) {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
      setSelectedBoxes(Array.from(checkboxes).map((checkbox) => checkbox.id));
    } else {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
      setSelectedBoxes([]);
    }
  }, [selectAll, isManuallySelected]);

  const handleSelectAll = () => {
    setIsManuallySelected(false);
    setSelectAll((prev) => !prev);
  };

  /**
   * @function handleSelection 
   * @param {boolean} state 
   * @param {string|number} id 
   * @description - handles individual card selection
   */
  const handleSelection = (state, id) => {
    setSelectedBoxes((prevSelectedBoxes) => {
      const updated = state ? [...prevSelectedBoxes, id] : prevSelectedBoxes.filter((boxId) => boxId !== id);

      setIsManuallySelected(true);

      if (updated.length === document.querySelectorAll(".cards-checkboxes").length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }

      return updated;
    });
  };

  return (
    <div className="manager-view-diary">
        <div>
          <div className="my-dashboard-header">
            {euser?.image && (
              <UserShortProfile
                employeeName={`${euser.firstName} ${euser.lastName}`}
                employeePronoun={euser.pronoun?.trim() || "N/A"}
                employeeDesignation={euser.jobDescription?.trim() || "N/A"}
                employeeID={euser.id || "N/A"}
                employeeUsername={euser.username?.trim() || "N/A"}
                employeeLocation={euser.city?.trim() || "N/A"}
                employeePicture={euser.image}
                employeeDisabled={!!euser.isDisabled}
                employeeContractEndDate={euser.contractEndDate || "N/A"}
                employeeDepartment={euser.department?.trim() || "N/A"}
                employeeIdvStatus={euser.trolleyIdvStatus}
                employeePersonalEmail={euser.personalEmail}
                showManagerLinks={true}
              />
            )}
          </div>
          {loading && <LoadingSpinner />}

          {!loading && (
            <div className="diaryMain">
              <div className="user-daily-diary-filters">
                <div>
                  <FloatLabel>
                    <Calendar 
                      inputId="user-diary-date-picker"
                      value={selectedDiaryDate}
                      onChange={(e) => setSelectedDiaryDate(e.value)}
                      placeholder="Select a date"
                      maxDate={new Date()}
                      dateFormat="dd/mm/yy"
                    />
                    <label htmlFor="user-diary-date-picker">Select a date</label>
                  </FloatLabel>
                </div>
                <WisdomDropdown 
                  placeholder="Select a timezone"
                  value={timezone}
                  options={timezones}
                  optionalLabel="label"
                  optionalValue="value"
                  onChange={changeTimeOffset}
                />
                {loading && <LoadingSpinner />}
              </div>
              <div className="user-daily-diary-btns">
                <Button 
                  label={selectedBoxes.length <= 0 ? "Select all" : "Clear selection"} 
                  icon={selectedBoxes.length <= 0 ? "pi pi-check" : "pi pi-times"}
                  severity="info" 
                  onClick={handleSelectAll}
                />
                <Can permission={PERMISSIONS.trackingUsersByIdCards_put}>
                  <Button label="Update Timecard" severity="warning" icon="pi pi-file-edit" onClick={handleUpdateCards} disabled={selectedBoxes.length <= 0}/>

                </Can>
                <Button label="Timecard Status" severity="info" icon="pi pi-info-circle" onClick={() => setVisible(!visible)}/>
              </div>
            

              {summary.length <= 0 && !loading && <p className="no-data-msg">No timecards for the selected day</p>}

              <DiaryTimeLine
                data={summary}
                handleSelection={handleSelection} 
              />
            </div>
          )}
        </div>

      <Dialog
        dismissableMask
        header="Update Timecards"
        visible={dialogVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          setSelectedProject(null);
          setSelectedStatus(null);
          if (!dialogVisible) return;
          setDialogVisible(false);
        }}
      >
        <div>
          <div className="card flex justify-content-center">
            <Dropdown
              value={selectedProject}
              onChange={(e) => setSelectedProject(e.value)}
              options={projects}
              optionLabel="name"
              placeholder="Select a Project"
              className="w-full md:w-14rem"
            />
          </div>
          <div className="card flex justify-content-center mt-2">
            <Dropdown
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.value)}
              options={cardStatus}
              optionLabel="name"
              placeholder="Select a Status"
              className="w-full md:w-14rem"
            />
          </div>
        </div>
        <div className="update-timecards-save-btn">
          <Can permission={PERMISSIONS.trackingUsersByIdCards_put}>
            <Button 
              label="Save"
              icon="pi pi-check"
              onClick={handleSubmitUpdateTimeCard}
              disabled={!selectedProject && !selectedStatus}
            />
          </Can>
        </div>
      </Dialog>

      <Dialog
        dismissableMask
        header="Timecards Status"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <div>
          <table className="timecard-dialog">
            <thead className="timecard-dialog">
              <tr className="timecard-dialog">
                <th className="timecard-dialog">Status</th>
                <th className="timecard-dialog">Description</th>
                <th className="timecard-dialog">Added to Payroll</th>
              </tr>
            </thead>
            <tbody className="timecard-dialog">
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Idle</td>
                <td className="timecard-dialog">
                  Idle timecard is when the tracker did not identify any activity.
                </td>
                <td className="timecard-dialog">No</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Productive</td>
                <td className="timecard-dialog">A productive and valid timecard</td>
                <td className="timecard-dialog">Yes</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Manual Time</td>
                <td className="timecard-dialog">A timecard created after MT was approved</td>
                <td className="timecard-dialog">Yes</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Marked</td>
                <td className="timecard-dialog">
                  An idle timecard marked as not idle by the user. Example: the user was in a meeting or
                  watching a training.
                </td>
                <td className="timecard-dialog">Yes</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Rejected</td>
                <td className="timecard-dialog">A timecard that has been rejected by the manager</td>
                <td className="timecard-dialog">No</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="timecards-status-ok-btn">
          <Button label="Ok" severity="success" onClick={() => setVisible(!visible)} autoFocus/>

        </div>
      </Dialog>
    </div>
  );
}

export default UserDailyDiary;
